export const HEX_FEATURE_ID = 'warlock:hex';
const ineligible = (reasonCode) => ({ status: 'ineligible', featureId: HEX_FEATURE_ID, featureLabel: 'Hex', reasonCode });
const ATTACK_ROLL_KINDS = new Set(['weapon', 'unarmed', 'spell']);

/** 2024 Hex: every hit with an attack roll on the cursed creature deals an extra 1d6 Necrotic damage. */
export const evaluateHex = ({ context, queries = {} }) => {
  if (!ATTACK_ROLL_KINDS.has(context?.attack?.kind)) return ineligible('not-attack-roll');
  const cursed = (queries.activeEffects || []).some((effect) => effect?.definitionId === 'spell:hex' && effect.targetCombatantId != null
    && String(effect.targetCombatantId) === String(context.target?.combatantId) && String(effect.sourceCombatantId) === String(context.attacker?.combatantId));
  if (!cursed) return ineligible('target-not-cursed');
  return {
    status: 'automatic', featureId: HEX_FEATURE_ID, featureLabel: 'Hex', reasonCode: 'cursed-target',
    components: [{ id: HEX_FEATURE_ID, label: 'Hex', source: { type: 'spell', featureId: HEX_FEATURE_ID }, dice: { count: 1, sides: 6 }, flat: 0,
      damageType: { mode: 'explicit', value: 'necrotic' }, critical: { dice: 'double' } }],
    claims: [],
  };
};
